import Vue from 'vue'
import { fetchWithToken } from '@/utils/keycloak'
import config from '@/utils/apiUtils'

export const contexts = {
  BOUCHERIE_CONTEXT: 'boucherie',
  POISSONNERIE_CONTEXT: 'poissonnerie'
}

export const contextDatas = [
  {
    id: contexts.POISSONNERIE_CONTEXT,
    name: 'Poissonnerie',
    logo: 'logo.png',
    drawerClass: 'drawer-poissonnerie',
    primary: '#376374',
    secondary: '#8AC3D5'
  },
  {
    id: contexts.BOUCHERIE_CONTEXT,
    name: 'Boucherie',
    logo: 'carnot.png',
    drawerClass: 'drawer-boucherie',
    primary: '#9d0419',
    secondary: '#f19ca4'
  }
]

const CONTEXT_STORAGE_KEY = 'hublot_current_context'

export const state = {
  currentContext: localStorage.getItem(CONTEXT_STORAGE_KEY) || contexts.POISSONNERIE_CONTEXT,
  availableContexts: [contexts.POISSONNERIE_CONTEXT]
}

export const mutations = {
  switchContext(currentState, currentContext) {
    console.log('switchContext, prec : ', currentState.context.currentContext, '', 'new : ', currentContext)
    currentState.context.currentContext = currentContext
    localStorage.setItem(CONTEXT_STORAGE_KEY, currentContext)
  },
  switchAvailableContexts(currentState, contextList) {
    currentState.context.availableContexts = contextList
  }
}

export const getters = {
  currentApp(currentState) {
    return currentState.context.currentContext
  },
  contextClientId(currentState, getters, rootState) {
    if (currentState.context.currentContext === contexts.BOUCHERIE_CONTEXT)
      return rootState.authentication.userProfile.attributes.carnot_clientid[0]
    return rootState.authentication.userProfile.attributes.hublot_clientid[0]
  },
  // Identifiant permanent de l'admin (volatile clientId est swapé lors d'une impersonation depuis le CRM).
  // Présent uniquement sur les comptes admin (hublot_admin_id / carnot_admin_id).
  contextAdminId(currentState, _getters, rootState) {
    const attributes = rootState.authentication.userProfile?.attributes || {}
    if (currentState.context.currentContext === contexts.BOUCHERIE_CONTEXT) {
      return attributes.carnot_admin_id?.[0] || null
    }
    return attributes.hublot_admin_id?.[0] || null
  },
  // Vrai si la session courante est en train d'impersonate un magasin.
  // Si l'attribut admin_id n'est pas exposé en claim (pas de Protocol Mapper Keycloak),
  // on retombe sur le rôle realm `hublot_admin` : un admin avec un clientId courant = impersonation.
  isImpersonating(_state, getters, rootState) {
    const adminId = getters.contextAdminId
    const clientId = getters.contextClientId
    if (!clientId) return false
    if (adminId) return String(adminId) !== String(clientId)
    const roles = rootState.authentication.userProfile?.realmAccess?.roles
      || rootState.authentication.userProfile?.realm_access?.roles
      || []
    return roles.includes('hublot_admin')
  },
}

export const actions = {
  switchContext({commit}, currentContext) {
    commit('switchContext', currentContext)
  },
  setAvailableContexts({commit}, contextList) {
    commit('switchAvailableContexts', contextList)
  },
  stopImpersonate({ commit, getters }) {
    const currentContext = getters.currentApp
    const app = currentContext === contexts.BOUCHERIE_CONTEXT ? 'carnot' : 'hublot'
    return fetchWithToken(`${config(currentContext).keycloakAuthBackend}impersonate`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ app }),
    })
      .then(response => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        return response.json()
      })
  },
}

export default {
  actions,
  mutations,
  state,
  contexts,
  contextDatas,
  getters
}
